import { createSlice, createAction } from '@reduxjs/toolkit';
import { RootState } from 'index';
import ResourceList from 'lib/jsonApi/ResourceList';
import { resetStore } from 'rdx/modules/app/slice';
import { PanelMatchingAttributes } from 'types/experiments';
import { PanelReagentsAttributes } from 'types/panels';
import { GenericActionPayload } from 'types/redux-types';

type PanelDetailSliceState = {
  panelReagents: ResourceList<PanelReagentsAttributes> | null,
  cytometerMatching: ResourceList<PanelMatchingAttributes> | null,
}

const initialState: PanelDetailSliceState = {
  panelReagents: null,
  cytometerMatching: null,
};

const requestPanelReagents = createAction<GenericActionPayload>('requestPanelReagents');
const requestHybrisCartUrl = createAction('requestHybrisCartUrl');
const requestPanelCytometerMatching = createAction<GenericActionPayload>('requestPanelCytometerMatching');

export const panelReagentsSlice = createSlice({
  name: 'panelDetails',
  initialState,
  reducers: {
    setPanelReagents: (state, action) => ({
      ...state,
      panelReagents: action.payload,
    }),
    setPanelCytometerMatching: (state, action) => ({
      ...state,
      cytometerMatching: action.payload,
    }),
  },
  extraReducers: (builder) => {
    builder.addCase(resetStore.type, () => initialState);
  },
});

const {
  setPanelReagents,
  setPanelCytometerMatching,
} = panelReagentsSlice.actions;

// Actions
export {
  requestPanelReagents,
  requestHybrisCartUrl,
  requestPanelCytometerMatching,
  setPanelReagents,
  setPanelCytometerMatching,
};

// Selectors
export const getPanelReagents = (state: RootState) => state.panelDetails.panelReagents;
export const getPanelCytometerMatching = (state: RootState) => state.panelDetails.cytometerMatching;

// Reducer
export default panelReagentsSlice.reducer;
